import { SxProps } from '@mui/material';
import {
  blueActive,
  greenDefault,
  greenHover,
  grey13,
  yellow,
  yellow3,
  yellowDefault, yellowHover
} from 'app/components/ThemeProvider/colors';
import {getTheme} from "app/components/ThemeProvider/theme";

const theme = getTheme('light');

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '6px 16px',

  [theme.breakpoints.down('sm')]: {
    p: '8px !important',
  },
};


export const notif: SxProps = {
  background: grey13,
  display: 'flex',
  borderRadius: '30px',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: '20px',
  p: '2px 8px 0 8px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
  lineHeight: 1,
};
export const accordionBox: SxProps = {
  marginTop: '28px',
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
};

export const cardOrderBtn: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: yellow,
  height: '60px',
  justifyContent: 'center',
  gap: '12px',
  '&:hover': { background: yellow3 },
};

export const instantBox: SxProps = {
  display: 'flex',
  padding: '72px 0',
  alignItems: 'center',
  textAlign: 'center',
  flexDirection: 'column',
  backgroundColor: 'white',
  gap: '20px'
}

export const instantMainText: SxProps = {
  fontSize: '24px',
  fontWeight: 600
}

export const instantText: SxProps = {
  fontSize: '18px',
  maxWidth: '743px'
}

export const registrBox: SxProps = {
    p: '40px',
    backgroundColor: 'white',
    minWidth: '335px',
    [theme.breakpoints.down('sm')]: {
      p: '24px 20px 32px 20px' ,
    },
}

export const statusPayment = (status?: number) => {
  return {
    borderRadius: '80px',
    height: '32px',
    p: '0px 16px !important',
    display: 'flex',
    gap: '8px',
    backgroundColor: status === 2 ? greenDefault : status === 3 ? yellowDefault : null,
    '&:hover': { backgroundColor: status === 2 ? greenHover : status === 3 ? yellowHover : null },
    [theme.breakpoints.down('sm')]: {
      p: '8px !important',
    },
  }
};